import { ContentAccountRecovery } from './ContentAccountRecovery.model';
import { ContentLogin } from './cntentlogin.model';
import { ContentBusinessType } from './contentbusinesstype.model';
import { ContentContactUs } from './contentcontactus.model';
import { ContentInterstitialBanner } from './contentinterstitialbanner.model';
import { ContentLoggedInMilesLabel } from './contentloggedInMilesLabel.model';
import { ContentMyDelta } from './contentmydelta.model';
import { ContentNotification } from './contentnotification.model';
import { ContentSearchFeed } from './contentsearchfeed.model';
import { ContentSignUp } from './contentsingup.model';
import { ContentTodayPanel } from './contenttodaypanel.model';

export class ContentAuxiliaryNavigation {
  id: any;
  label: any;
  details: any;

  constructor(id: any, contentjson?: any) {
    if (contentjson) {
      this.id = id;
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      this.details = this.fillDetails(contentjson);
    }
  }

  private fillDetails(contentjson?: any): any {
    let details: any;
    if (contentjson) {
      if (contentjson['id']) {
        switch (contentjson['id']) {
          case 'searchfeed': {
            details = new ContentSearchFeed(contentjson);
            break;
          }
          case 'notification': {
            details = new ContentNotification(contentjson);
            break;
          }
          case 'todayPanel': {
            details = new ContentTodayPanel(contentjson);
            break;
          }
          case 'myFlightPanel': {
            details = new ContentMyDelta(contentjson);
            break;
          }
          case 'login': {
            details = new ContentLogin(contentjson);
            break;
          }
          case 'loggedInMilesLabel': {
            details = new ContentLoggedInMilesLabel(contentjson);
            break;
          }
          case 'signup': {
            details = new ContentSignUp(contentjson);
            break;
          }
          case 'contactUs': {
            details = new ContentContactUs(contentjson);
            break;
          }
          case 'profileSelector': {
            details = new ContentBusinessType(contentjson);
            break;
          }
          case 'interstitialBanner': {
            details = new ContentInterstitialBanner(contentjson);
            break;
          }
          case 'accountrecovery': {
            details = new ContentAccountRecovery(contentjson);
            break;
          }
          default: {
            details = null;
            break;
          }
        }
      }
    }
    return details;
  }
}
